import { Type } from 'typebox';
import { Guardian } from './guardian.js';
import { Person } from './person.js';
import { TargetAgeOrGradeCodec } from '../reference/target-age-or-grade.js';
import { Trackable } from './trackable.js';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { ShortIsoCalendarDateCodec, TypeBoxShortIsoCalendarDateFormat } from '../../utils/register-typebox-short-iso-calendar-date-format.js';
export const ChildStatuses = {
    active: 'active',
    suspended: 'suspended',
    graduated: 'graduated',
    waiting: 'waiting',
    scheduled: 'scheduled',
    deleted: 'deleted',
    touring: 'touring',
    visited: 'visited',
    interested: 'interested',
    purged: 'purged',
    closed: 'closed',
    unknown: 'unknown'
};
export const ChildStatus = Type.Union([
    Type.Literal(ChildStatuses.active),
    Type.Literal(ChildStatuses.suspended),
    Type.Literal(ChildStatuses.graduated),
    Type.Literal(ChildStatuses.waiting),
    Type.Literal(ChildStatuses.scheduled),
    Type.Literal(ChildStatuses.deleted),
    Type.Literal(ChildStatuses.touring),
    Type.Literal(ChildStatuses.visited),
    Type.Literal(ChildStatuses.interested),
    Type.Literal(ChildStatuses.purged),
    Type.Literal(ChildStatuses.closed),
    Type.Literal(ChildStatuses.unknown)
]);
export const ChildStatusCodec = createFallbackStringEnumCodec(ChildStatuses, ChildStatuses.unknown);
export const DimensionData = Type.Object({
    id: Type.String({ minLength: 1 }),
    level: Type.Integer()
});
export const Child = Type.Evaluate(Type.Intersect([
    Type.Omit(Person, ['email', 'mobileNumber', 'workNumber', 'homeNumber']),
    Trackable,
    Type.Object({
        dimensionIds: Type.Array(Type.String({ minLength: 1 })),
        dimensionData: Type.Optional(Type.Array(DimensionData)),
        tsgId: Type.Optional(Type.Integer()),
        ngpId: Type.Optional(Type.String({ minLength: 1 })),
        birthDate: Type.Optional(ShortIsoCalendarDateCodec),
        person: Type.String({ minLength: 1 }),
        scheduleKey: Type.String({ minLength: 1 }),
        specialNote: Type.Optional(Type.String({ minLength: 1 })),
        status: ChildStatusCodec,
        childType: Type.String({ minLength: 1 }),
        familyKey: Type.Optional(Type.String({ minLength: 1 })),
        tsgColorId: Type.Optional(Type.Integer()),
        targetAgeOrGradeKey: Type.Optional(TargetAgeOrGradeCodec),
        nextMedical: Type.Optional(Type.Unknown()),
        ifspServices: Type.Optional(Type.Boolean()),
        iepServices: Type.Optional(Type.Boolean()),
        freeAndReducedLunch: Type.Optional(Type.Boolean()),
        assessSpanishObjectives: Type.Optional(Type.Boolean()),
        caseloadIds: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        weeksPremature: Type.Optional(Type.Integer()),
        lastScreeningDate: Type.Optional(Type.String({ format: TypeBoxShortIsoCalendarDateFormat })),
        latestSkillsAchieved: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        mealInterval: Type.Optional(Type.Integer()),
        bottleInterval: Type.Optional(Type.Integer()),
        bottleSize: Type.Optional(Type.Number()),
        diaperInterval: Type.Optional(Type.Integer()),
        sleepCheckInterval: Type.Optional(Type.Integer()),
        toiletCheckInterval: Type.Optional(Type.Integer()),
        medicationInterval: Type.Optional(Type.Integer()),
        applicationInterval: Type.Optional(Type.Integer()),
        guardians: Type.Optional(Type.Array(Guardian))
    })
]));
